import * as React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ReactPlayer from 'react-player'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { selectIsVisible, selectVideo } from '../redux/reducers/modal-player/modal-player.selectors'
import { setVideoPlayer } from '../redux/reducers/modal-player/modal-player.actions'

export const ModalPlayer = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const isVisible = useAppSelector(selectIsVisible)
  const video = useAppSelector(selectVideo)

  const onClose = () => {
    dispatch(setVideoPlayer({
      video: null,
      isVisible: false
    }))
  }

  return (
    <Dialog
      fullWidth={true}
      open={isVisible}
      onClose={onClose}
    >
      <DialogTitle>{t(`workouts.${video?.name}`, { defaultValue: video?.name })}</DialogTitle>
      <DialogContent>
        <ReactPlayer
          className='react-player'
          muted
          playing
          controls
          url={video?.videoUrl}
          width='100%'
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={onClose}>
          {t('general.btn.dismiss')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
